import "./whatsAppFloating.css";

function WhatsAppFloating() {
    return (
        <a href="https://wa.me/+542477204949" target="_blank" rel="noreferrer" className="wsfCont flex OoS"><img src="/images/icons/wsf.png" alt="WhatsApp" className='wsf'/></a>
    )
}

export default WhatsAppFloating